import { LoaderFunctionArgs } from 'react-router';
import { QueryClient } from '@tanstack/react-query';
import { getApplication, getApplicationOptions } from './api/getApplication';

export function applicationLoader(queryClient: QueryClient) {
    return async ({ params }: LoaderFunctionArgs) => {
        if (!params.appID) throw new Error('Missing application ID');

        const queryOptions = getApplicationOptions(params.appID);
        const cache = queryClient.getQueryData(queryOptions.queryKey);
        if (cache) return cache;

        const app = await getApplication(params.appID);
        queryClient.setQueryData(queryOptions.queryKey, app);
        return app;
    };
}
